import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Doggy?",
  "description": "",
  "published": "2007-05-19T00:00:00.000Z",
  "redirect_from": ["/blog/doggy/swizec/207"],
  "categories": "intrigues, linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://img153.imageshack.us/my.php?image=bigdoggieim5.jpg"
      }}><img parentName="a" {...{
          "src": "https://img153.imageshack.us/img153/9017/bigdoggieim5.th.jpg",
          "alt": "Free Image Hosting at www.ImageShack.us"
        }}></img></a></p>
    <p>{`Much cannot be said of this impressively huge doggy. The monster is apparently the biggest, or rather the most voluminous, dog in the world according to the Guinnes book of records. The thing is also supposed to have growth capabilities for the next two years.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      